// const api_url = 'http://localhost:3005/';
const api_url = 'https://art-exhibition-management-platform-api.onrender.com/';
export default api_url;
